import { EventDispatcher } from "three";
export const NODE_CONNECTION_TRIGGERED_EVENT_NAME = "triggered";
export const NODE_CONNECTION_TRIGGERED_EVENT = { type: NODE_CONNECTION_TRIGGERED_EVENT_NAME };
const _TypedNodeConnection = class {
  constructor(_node_src, _node_dest, _output_index = 0, _input_index = 0) {
    this._node_src = _node_src;
    this._node_dest = _node_dest;
    this._output_index = _output_index;
    this._input_index = _input_index;
    if (this._output_index == null) {
      throw "bad output index";
    }
    if (this._input_index == null) {
      throw "bad input index";
    }
    this._id = _TypedNodeConnection._next_id++;
    if (this._node_src.io.connections && this._node_dest.io.connections) {
      this._node_src.io.connections.addOutputConnection(this);
      this._node_dest.io.connections.addInputConnection(this);
    }
  }
  get id() {
    return this._id;
  }
  get node_src() {
    return this._node_src;
  }
  get node_dest() {
    return this._node_dest;
  }
  get output_index() {
    return this._output_index;
  }
  get input_index() {
    return this._input_index;
  }
  src_connection_point() {
    const node_src = this._node_src;
    const output_index = this._output_index;
    return node_src.io.outputs.namedOutputConnectionPoints()[output_index];
  }
  dest_connection_point() {
    const node_dest = this._node_dest;
    const input_index = this._input_index;
    return node_dest.io.inputs.namedInputConnectionPoints()[input_index];
  }
  disconnect(options = {}) {
    if (this._node_src.io.connections && this._node_dest.io.connections) {
      this._node_src.io.connections.removeOutputConnection(this);
      this._node_dest.io.connections.removeInputConnection(this);
    }
    if (options.setInput === true) {
      this._node_dest.io.inputs.setInput(this._input_index, null);
    }
  }
  _eventDispatcher() {
    return this.__eventDispatcher;
  }
  eventDispatcher() {
    return this.__eventDispatcher = this.__eventDispatcher || new EventDispatcher();
  }
};
export let TypedNodeConnection = _TypedNodeConnection;
TypedNodeConnection._next_id = 0;
